import React from 'react';
import { IconProps } from './types';

const Waypoints = (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.6 13.5" {...props}>
        <path
            fill="currentColor"
            d="M15.6 13.5H0L7.8 0l7.8 13.5ZM2.6 12H13L7.8 3l-5.2 9Z"
        />
    </svg>
);

export default Waypoints;
